<template>
  <v-container class="pt-0" style="background-color: white" fluid>
    <v-row no-gutters justify="center">
      <v-col cols="12" md="6" justify="center" align="center">
        <span style="font-size: 30px; color: #616161">
          <v-icon large class="pr-1 pb-2">mdi-format-list-bulleted-type</v-icon>
          Razones de ajustes de inventario</span>
      </v-col>
    </v-row>
    <v-card flat class="pt-3">
      <v-data-table :headers="headers" :items="adjustmentReasons" :search="search">
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>Razones</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            {{ adjustmentReasons.length }}
            <v-spacer> </v-spacer>
            <v-text-field class="mt-3" dense label="Buscar.." v-model="search" append-icon="search" single-line
              hide-details outlined></v-text-field>
            <v-spacer></v-spacer>
            <v-btn outlined dense color="success" @click="add_reason()">Nueva</v-btn>
          </v-toolbar>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" medium color="blue" @click="edit_reason(item)">
                mdi-pencil
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <!-- <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon> -->
        </template>
        <template v-slot:no-data>
          <v-row justify="center" class="pt-10">
            <v-icon size="80px">token</v-icon>
          </v-row>
          <v-row justify="center" class="pb-6"> No hay datos </v-row>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="dialog_edit" width="30%">
      <v-card flat>
        <v-card-title>
          <span class="headline">{{ is_edit ? 'Editar' : 'Nueva' }} razon</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="(dialog_edit = false)">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-card class="pt-3" flat>
              <v-row justify="center">
                <v-col cols="10" justify="center" align="center">
                  <v-text-field v-model="reason.description" label="Descripcion" outlined dense
                    hide-details></v-text-field>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col cols="10" justify="center" align="center">
                  <v-autocomplete v-model="reason.chart_of_account_id" :items="accounts" item-text="name" item-value="id"
                    label="Cuenta" outlined dense hide-details></v-autocomplete>
                </v-col>
              </v-row>
              <v-row justify="center" align="center">
                <v-col cols="5" justify="center" align="center">
                  <v-autocomplete v-model="reason.entry_type_id" :items="[{ value: 1, text: 'Debito' }, { value: 2, text: 'Credito' }]"
                    label="Tipo" outlined dense hide-details></v-autocomplete>
                </v-col>
                <v-col cols="5" align="end">
                  <v-switch v-model="reason.status" label="Estatus"> </v-switch>
                </v-col>
              </v-row>
            </v-card>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="(dialog_edit = false)">
            Cancelar
          </v-btn>
          <v-btn text color="success" @click="save_reason()">{{ is_edit ? 'Actualizar' : 'Guardar' }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
export default {
  data: () => ({
    search: null,
    dialog_edit: false,
    is_edit: false,
    reason: {
      description: null,
      chart_of_account_id: null,
      entry_type_id: null,
      status_id: null,
      status: false
    },
    accounts: [],
    adjustmentReasons: [],
    headers: [
      {
        text: "Razon",
        align: "start",
        sortable: false,
        value: "description",
      },
      { text: "Cuenta", value: "account_name" },
      { text: "Tipo", value: "entry_type" },
      { text: "Actions", value: "actions", sortable: false },
    ],
  }),
  mounted() {
    this.initialized();
  },
  computed: {},
  // watch: {},
  methods: {
    async initialized() {
      this.get_reasons();
      //CUENTAS
      const resultTypeAccounts = await this.api_Get("accounting/accountsUsable");
      let accounts=await resultTypeAccounts.json();
      accounts.forEach(element => {
        element.name=element.name+" (" +element.code+")"
        this.accounts.push({
          name: element.code+" - "+ element.name,
          id: element.id,
        
        })
      });
    },
    async get_reasons() {
      const request = await this.api_Get("inventory/adjustmentReasons");
      this.adjustmentReasons = await request.json();
    },
    edit_reason(reason) {
      this.reason = Object.assign({}, reason);
      this.reason.status = reason.status_id === 1;
      this.is_edit = true;
      this.dialog_edit = true;
    },
    add_reason() {
      this.reason.description = null;
      this.reason.chart_of_account_id = null;
      this.reason.entry_type_id = null;
      this.reason.status = true;
      this.is_edit = false;
      this.dialog_edit = true;
    },
    async save_reason() {
      if (this.reason.description == null || this.reason.description == '') {
        this.$toast.warning('Debe agregar la descripción');
        return;
      }
      if (this.reason.chart_of_account_id == null) {
        this.$toast.warning('Debe seleccionar la cuenta');
        return
      }
      if (this.reason.entry_type_id == null) {
        this.$toast.warning('Debe seleccionar el tipo');
        return
      }
      this.reason.status_id = this.reason.status ? 1 : 2;
      try {
        let result = null;
        if (this.is_edit) {
          result = await this.api_Put('inventory/update_adjustment_reason', this.reason);
        } else {
          result = await this.api_Post('inventory/save_adjustment_reason', this.reason);
        }
        if (result.status == 200) {
          this.$toast.success(`Razon ${this.is_edit ? 'actualizada' : 'guardada'} correctamente!`);
          this.dialog_edit = false;
        }
        this.get_reasons();
      } catch (error) {
        this.$toast.error(error.message);
        console.error(error.message);
      }
    }
  },
};
</script>